/*
  QB SEO and hygiene fixes that need the DOM (Stage X5, X6, X10, X2). Runs once, then watches for late markup.
  - X5: exactly one H1 per page. The theme makes the header logo an H1 on the home page (once per header row) and
    keeps its own product title H1 on the PDP under the qb title; those hidden or duplicate H1s become divs with
    the same classes, so the visible heading is the only H1 in the rendered page.
  - X6: images with no alt get one — product media on the PDP from the print name and garment, cards from their
    title, everything else from the nearest heading; purely decorative images are marked as such.
  - X10: links that open a new tab carry rel="noopener".
  - X2: the theme's own product JSON-LD (snippets/product-scripts-and-schema, no setting) is removed so the page
    carries one Product graph — the qb one in the head.
*/
(function () {
  if (window.__qbSeo) return;
  window.__qbSeo = true;
  function retag(el) {
    var d = document.createElement('div');
    for (var i = 0; i < el.attributes.length; i++) d.setAttribute(el.attributes[i].name, el.attributes[i].value);
    d.setAttribute('data-qb-was', 'h1');
    while (el.firstChild) d.appendChild(el.firstChild);
    el.parentNode.replaceChild(d, el);
    return d;
  }
  function headings() {
    var hs = Array.prototype.slice.call(document.querySelectorAll('h1'));
    if (hs.length < 2) return;
    var keep = document.querySelector('h1.qb-product-title') || document.querySelector('main h1:not(.header__logo):not(.header__logo-text)') || hs[0];
    hs.forEach(function (h) { if (h !== keep) retag(h); });
  }
  function nameFromTitle() {
    var h = document.querySelector('h1.qb-product-title, main h1');
    var sub = document.querySelector('.qb-product-title__sub');
    var name = h ? h.textContent.trim() : '';
    if (sub) { var parts = sub.textContent.split('·'); if (parts[1]) name += ' ' + parts[1].trim(); }
    return name;
  }
  function alts(root) {
    var imgs = (root.querySelectorAll ? root.querySelectorAll('img:not([alt]), img[alt=""]') : []);
    var pdpName = document.body.classList.contains('template-product') ? nameFromTitle() : '';
    Array.prototype.forEach.call(imgs, function (img) {
      if (img.getAttribute('role') === 'presentation' || img.getAttribute('aria-hidden') === 'true') return;
      var card = img.closest('.product-item, .recently-viewed-product-item, .collection-item, .qb-good-company__tile, .qb-edit-tile');
      var label = '';
      if (card) {
        var t = card.querySelector('.product-item__product-title, .recently-viewed-product-item__title, .collection-item__title, .qb-good-company__name, .collection-item__label');
        label = t ? t.textContent.trim().replace(/\s+/g, ' ') : '';
      } else if (pdpName && img.closest('.product__media, .product__media-item, .product__media-wrapper, [data-media-id]')) {
        label = pdpName + ', QB Men';
      }
      if (!label) {
        var sec = img.closest('.shopify-section'); var hh = sec && sec.querySelector('h1, h2, h3');
        label = hh ? hh.textContent.trim().replace(/\s+/g, ' ') : '';
      }
      if (label) img.setAttribute('alt', label); else img.setAttribute('alt', '');
    });
  }
  function noopener(root) {
    var links = root.querySelectorAll ? root.querySelectorAll('a[target="_blank"]') : [];
    Array.prototype.forEach.call(links, function (a) { var rel = (a.getAttribute('rel') || '').split(/\s+/).filter(Boolean); if (rel.indexOf('noopener') < 0) { rel.push('noopener'); a.setAttribute('rel', rel.join(' ')); } });
  }
  function themeSchema(root) {
    var scripts = root.querySelectorAll ? root.querySelectorAll('script[type="application/ld+json"]') : [];
    Array.prototype.forEach.call(scripts, function (s) {
      if (s.closest('head')) return;
      if (/"@type"\s*:\s*"Product"/.test(s.textContent) && !/"@graph"/.test(s.textContent)) s.parentNode.removeChild(s);
    });
  }
  function run(root) { alts(root); noopener(root); themeSchema(root); }
  headings(); run(document);
  new MutationObserver(function (rs) { rs.forEach(function (r) { r.addedNodes.forEach(function (n) { if (n.nodeType === 1) run(n); }); }); }).observe(document.documentElement, { childList: true, subtree: true });
})();
